/* ============================================================
   Carrusel de producto v2 - Tueste Cafe (Getmore)
   Vanilla JS + CSS scroll-snap. Sin Slick, sin jQuery.
   Conserva: sync de thumbnails, flechas, dots mobile,
   sync de variante (featured_media), zoom modal mobile
   (tap en lupita o en la foto) y re-init con Product Linking
   (via connectedCallback de custom elements).
   ============================================================ */
(function () {
  'use strict';

  var MOBILE_MQ = 740;

  function onFrame(fn) {
    var ticking = false;
    return function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        fn();
      });
    };
  }

  /* ------------------- Carrusel principal ------------------- */
  class ProductCarouselV2 extends window.HTMLElement {
    connectedCallback() {
      if (this.initialized === true) return;
      this.initialized = true;
      window.setTimeout(this.setup.bind(this), 0);
    }

    setup() {
      this.$track = this.querySelector('.product-main-carousel');
      if (this.$track === null) return;
      this.$slides = Array.prototype.slice.call(this.$track.querySelectorAll('.main-slide'));
      this.$thumbsTrack = this.querySelector('.product-thumbnails-carousel');
      this.$thumbs = Array.prototype.slice.call(this.querySelectorAll('.thumbnail-slide'));
      this.$wrapper = this.querySelector('.product-main-carousel-wrapper');
      this.currentIndex = 0;

      this.buildDots();
      this.bindArrows();
      this.bindThumbnails();
      this.bindScroll();
      this.bindImageTap();
      this.bindVariantSync();
      this.goToInitialVariantSlide();
      this.updateUI();
    }

    slideStep() {
      if (this.$slides.length < 2) return this.$track.clientWidth || 1;
      return (this.$slides[1].offsetLeft - this.$slides[0].offsetLeft) || 1;
    }

    /* Indice a partir del scroll. Cuando los slides son mas angostos
       que el contenedor (mobile), el ultimo slide no alcanza su punto
       de inicio: al llegar al final del scroll se fuerza el ultimo. */
    indexFromScroll() {
      var maxScroll = this.$track.scrollWidth - this.$track.clientWidth;
      if (maxScroll > 0 && maxScroll - this.$track.scrollLeft <= 2) {
        return this.$slides.length - 1;
      }
      var index = Math.round(this.$track.scrollLeft / this.slideStep());
      return Math.max(0, Math.min(index, this.$slides.length - 1));
    }

    goTo(index, instant) {
      if (this.$slides.length === 0) return;
      var clamped = Math.max(0, Math.min(index, this.$slides.length - 1));
      var $target = this.$slides[clamped];
      this.currentIndex = clamped;
      this.$track.scrollTo({
        left: $target.offsetLeft - this.$slides[0].offsetLeft,
        behavior: instant === true ? 'auto' : 'smooth'
      });
      this.updateUI();
    }

    goToMedia(mediaId, instant) {
      var $slide = this.$track.querySelector('.main-slide[data-media-id="' + mediaId + '"]');
      if ($slide === null) return;
      this.goTo(this.$slides.indexOf($slide), instant);
    }

    currentMediaId() {
      var $slide = this.$slides[this.currentIndex];
      return $slide ? $slide.getAttribute('data-media-id') : null;
    }

    updateUI() {
      var $currentSlide = this.$slides[this.currentIndex];
      var currentDataIndex = $currentSlide ? $currentSlide.getAttribute('data-index') : null;

      this.$thumbs.forEach(function ($thumb) {
        var isCurrent = $thumb.getAttribute('data-index') === currentDataIndex;
        $thumb.classList.toggle('is-current', isCurrent);
        if (isCurrent) this.scrollThumbIntoView($thumb);
      }, this);

      if (this.$dotButtons) {
        this.$dotButtons.forEach(function ($dot, i) {
          $dot.classList.toggle('is-active', i === this.currentIndex);
        }, this);
      }
    }

    scrollThumbIntoView($thumb) {
      var $c = this.$thumbsTrack;
      if ($c === null) return;
      if (window.innerWidth > MOBILE_MQ) {
        if ($thumb.offsetTop < $c.scrollTop || $thumb.offsetTop + $thumb.offsetHeight > $c.scrollTop + $c.clientHeight) {
          $c.scrollTo({ top: $thumb.offsetTop, behavior: 'smooth' });
        }
      } else {
        if ($thumb.offsetLeft < $c.scrollLeft || $thumb.offsetLeft + $thumb.offsetWidth > $c.scrollLeft + $c.clientWidth) {
          $c.scrollTo({ left: $thumb.offsetLeft, behavior: 'smooth' });
        }
      }
    }

    buildDots() {
      if (this.$slides.length <= 1 || this.$wrapper === null) return;
      var $dots = document.createElement('div');
      $dots.className = 'carousel-dots-v2';
      this.$dotButtons = this.$slides.map(function (_, i) {
        var $dot = document.createElement('button');
        $dot.type = 'button';
        $dot.setAttribute('aria-label', 'Ir a imagen ' + (i + 1));
        $dot.addEventListener('click', this.goTo.bind(this, i, false));
        $dots.appendChild($dot);
        return $dot;
      }, this);
      this.$wrapper.appendChild($dots);
    }

    bindArrows() {
      var $prev = this.querySelector('.product-carousel-arrow-prev');
      var $next = this.querySelector('.product-carousel-arrow-next');
      var self = this;
      if ($prev !== null) {
        $prev.addEventListener('click', function () {
          var total = self.$slides.length;
          self.goTo((self.currentIndex - 1 + total) % total);
        });
      }
      if ($next !== null) {
        $next.addEventListener('click', function () {
          self.goTo((self.currentIndex + 1) % self.$slides.length);
        });
      }
    }

    bindThumbnails() {
      var self = this;
      this.$thumbs.forEach(function ($thumb) {
        var activate = function () {
          var $slide = self.$track.querySelector('.main-slide[data-index="' + $thumb.getAttribute('data-index') + '"]');
          if ($slide !== null) self.goTo(self.$slides.indexOf($slide));
        };
        $thumb.addEventListener('click', activate);
        $thumb.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            activate();
          }
        });
      });
    }

    bindScroll() {
      var self = this;
      this.$track.addEventListener('scroll', onFrame(function () {
        var index = self.indexFromScroll();
        if (index !== self.currentIndex) {
          self.currentIndex = index;
          self.updateUI();
        }
      }), { passive: true });
    }

    bindImageTap() {
      var self = this;
      this.$track.querySelectorAll('.main-slide-image').forEach(function ($slide) {
        $slide.addEventListener('click', function () {
          if (window.innerWidth > MOBILE_MQ) return;
          var $zoom = document.querySelector('product-zoom-v2');
          if ($zoom !== null && typeof $zoom.open === 'function') {
            $zoom.open(self.currentMediaId());
          }
        });
      });
    }

    bindVariantSync() {
      var $form = document.querySelector('.main-product-form');
      var style = $form !== null ? $form.getAttribute('data-variants-style') : 'combined';
      var $variants = document.querySelector('variant-' + style);
      if ($variants === null) return;
      var self = this;
      $variants.addEventListener('variant::changed', function () {
        var variant = $variants.currentVariant;
        if (variant == null || variant.featured_media == null) return;
        self.goToMedia(variant.featured_media.id);
      });
    }

    goToInitialVariantSlide() {
      var $json = document.querySelector('#selectedVariant');
      if ($json === null) return;
      try {
        var variant = JSON.parse($json.textContent);
        if (variant != null && variant.featured_media != null) {
          this.goToMedia(variant.featured_media.id, true);
        }
      } catch (error) {
        window.console.warn('carousel-v2: selectedVariant JSON invalido', error);
      }
    }
  }

  /* ------------------- Zoom mobile ------------------- */
  class ProductZoomV2 extends window.HTMLElement {
    connectedCallback() {
      if (this.initialized === true) return;
      this.initialized = true;
      window.setTimeout(this.setup.bind(this), 0);
    }

    setup() {
      this.$modal = this.querySelector('.product-carousel-zoom-wrapper');
      this.$track = this.querySelector('.product-carousel-zoom');
      if (this.$modal === null || this.$track === null) return;
      this.$slides = Array.prototype.slice.call(this.$track.querySelectorAll('.zoom-slide'));
      this.hydrated = false;
      this.currentIndex = 0;

      this.buildDots();
      this.bindButtons();
      this.bindScroll();
      this.bindResize();
    }

    /* Las imagenes del zoom no cargan hasta el primer uso */
    hydrate() {
      if (this.hydrated === true) return;
      this.$track.querySelectorAll('img[data-src]').forEach(function ($img) {
        $img.src = $img.getAttribute('data-src');
        var srcset = $img.getAttribute('data-srcset');
        var sizes = $img.getAttribute('data-sizes');
        if (srcset !== null) $img.srcset = srcset;
        if (sizes !== null) $img.sizes = sizes;
        $img.removeAttribute('data-src');
      });
      this.hydrated = true;
    }

    open(mediaId) {
      this.hydrate();
      this.$modal.classList.add('show');
      document.body.classList.add('zoom-modal-open');
      var index = 0;
      if (mediaId != null) {
        var $slide = this.$track.querySelector('.zoom-slide[data-media-id="' + mediaId + '"]');
        if ($slide !== null) index = this.$slides.indexOf($slide);
      }
      this.goTo(index, true);
    }

    close() {
      this.$modal.classList.remove('show');
      document.body.classList.remove('zoom-modal-open');
    }

    goTo(index, instant) {
      if (this.$slides.length === 0) return;
      var clamped = Math.max(0, Math.min(index, this.$slides.length - 1));
      var $target = this.$slides[clamped];
      this.currentIndex = clamped;
      this.$track.scrollTo({
        left: $target.offsetLeft - this.$slides[0].offsetLeft,
        behavior: instant === true ? 'auto' : 'smooth'
      });
      this.updateDots();
    }

    buildDots() {
      if (this.$slides.length <= 1) return;
      var $dots = document.createElement('div');
      $dots.className = 'zoom-dots-v2';
      this.$dotButtons = this.$slides.map(function (_, i) {
        var $dot = document.createElement('button');
        $dot.type = 'button';
        $dot.setAttribute('aria-label', 'Ir a imagen ' + (i + 1));
        $dot.addEventListener('click', this.goTo.bind(this, i, false));
        $dots.appendChild($dot);
        return $dot;
      }, this);
      this.$modal.appendChild($dots);
    }

    updateDots() {
      if (!this.$dotButtons) return;
      this.$dotButtons.forEach(function ($dot, i) {
        $dot.classList.toggle('is-active', i === this.currentIndex);
      }, this);
    }

    bindButtons() {
      var self = this;
      var $open = this.querySelector('.product-carousel-zoom-button');
      var $close = this.querySelector('.product-carousel-zoom-close-button');
      if ($open !== null) {
        $open.addEventListener('click', function () {
          var $carousel = self.closest('product-carousel-v2');
          var mediaId = null;
          if ($carousel !== null && typeof $carousel.currentMediaId === 'function') {
            mediaId = $carousel.currentMediaId();
          }
          self.open(mediaId);
        });
      }
      if ($close !== null) $close.addEventListener('click', this.close.bind(this));
    }

    bindScroll() {
      var self = this;
      this.$track.addEventListener('scroll', onFrame(function () {
        var step = 1;
        if (self.$slides.length > 1) {
          step = (self.$slides[1].offsetLeft - self.$slides[0].offsetLeft) || 1;
        }
        var index = Math.round(self.$track.scrollLeft / step);
        index = Math.max(0, Math.min(index, self.$slides.length - 1));
        if (index !== self.currentIndex) {
          self.currentIndex = index;
          self.updateDots();
        }
      }), { passive: true });
    }

    bindResize() {
      var self = this;
      window.addEventListener('resize', function () {
        if (window.innerWidth > MOBILE_MQ) self.close();
      });
    }
  }

  if (window.customElements.get('product-carousel-v2') === undefined) {
    window.customElements.define('product-carousel-v2', ProductCarouselV2);
  }
  if (window.customElements.get('product-zoom-v2') === undefined) {
    window.customElements.define('product-zoom-v2', ProductZoomV2);
  }
})();